import axios from "axios";
import { IApplication } from "./IApplication";
import { IUserService, UserService } from "./services/user";
import { AxiosClient } from "../infrastructure/axiosClient";
import { UserApi } from "../infrastructure/apis/user";

export class Application implements IApplication {
    public static readonly instance: Application = new Application();

    public readonly userService: IUserService;

    private constructor() {
        const _axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
        });

        console.log(process.env.REACT_APP_API_URL);

        const axiosClient = new AxiosClient(_axios);

        const userApi = new UserApi(axiosClient);

        this.userService = new UserService(userApi);
    }
}
